import { useSpecificHabitMemoizedSchedule } from "redux/selectors";

export const useIsDayScheduled = (dayOfWeek, habitid) => {
  const { habit } = useSpecificHabitMemoizedSchedule(habitid);
  return habit?.schedule?.[dayOfWeek] ?? true; // if no schedule (legacy habits), we assume it is scheduled
};
